import request from '@/utils/request'
const qs = require('qs')
export function listLabaRugi(data) {
  return request({
    url: '/report_keuangan/list_laba_rugi',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listNeraca(data) {
  return request({
    url: '/report_keuangan/list_neraca',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportFinance.js